import * as React from 'react';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
var EGStripe = function () { return (React.createElement(Experiment, { name: "EG_Affiliates_Link_Toolbar_v1" },
    React.createElement(ExperimentControl, null),
    React.createElement(ExperimentVariant, { bucket: 1 },
        React.createElement("header", { className: "eg-stripe-toolbar" },
            React.createElement("div", { className: "eg-stripe-toolbar-container" }, "EG STRIPE CONTENT HERE"))))); };
export { EGStripe };
//# sourceMappingURL=eg-stripe.js.map